import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { Tba, TbaTransactionsPayload, TbaListForStudyResponse } from '../models';

@Injectable()
export class TbasService extends BaseService<Tba> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public listForStudy(studyId: number, filter?: string): Observable<TbaListForStudyResponse> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}study/${studyId}/`);

    return this.http.get<any>(apiUrl);
  }

  public listTransactions(id: number, filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}${id}/transactions`);

    return this.http.get<any>(apiUrl);
  }

  public listSuitableTransactions(id: number, filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}${id}/transactions/suitable`);

    return this.http.get<any>(apiUrl);
  }

  public listSuitableUcTransactions(id: number, filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}${id}/transactions/uncontrolled/suitable`);

    return this.http.get<any>(apiUrl);
  }

  public listUcTransactions(id: number, filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}${id}/transactions/uncontrolled`);

    return this.http.get<any>(apiUrl);
  }

  public removeTransaction(tbaId: number, transactionId: number): Observable<any> {
    const apiUrl = `${this.getResourceUrl()}${tbaId}/transactions/${transactionId}`;

    return this.http.delete<any>(apiUrl);
  }

  public removeUcTransaction(tbaId: number, transactionId: number): Observable<any> {
    const apiUrl = `${this.getResourceUrl()}${tbaId}/transactions/uncontrolled/${transactionId}`;

    return this.http.delete<any>(apiUrl);
  }

  public getParameters(tbaId: number): Observable<any> {
    const apiUrl = `${this.getResourceUrl()}${tbaId}/parameters`;

    return this.http.get<any>(apiUrl);
  }

  public getAllowedParameters(tbaId: number, controlled = true): Observable<any> {
    const apiUrl = `${this.getResourceUrl()}${tbaId}/parameters/allowed?controlled=${controlled}`;

    return this.http.get<any>(apiUrl);
  }

  public getRelatedParameters(tbaId: number): Observable<any> {
    const apiUrl = `${this.getResourceUrl()}${tbaId}/parameters/related`;

    return this.http.get<any>(apiUrl);
  }

  public getUcParameters(tbaId: number, filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}${tbaId}/parameters/uncontrolled`);

    return this.http.get<any>(apiUrl);
  }

  public saveControlled(tbaId: number, data: TbaTransactionsPayload): Observable<any> {
    return this.http.put<any>(`${this.getResourceUrl()}${tbaId}/transactions`, data);
  }

  public saveUncontrolled(tbaId: number, data): Observable<any> {
    return this.http.put<any>(`${this.getResourceUrl()}${tbaId}/transactions/uncontrolled`, data);
  }

  public getSearchStrategy(tbaId: number): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}${tbaId}/search-strategy`);
  }

  public updateSearchStrategy(tbaId: number, data: object): Observable<any> {
    return this.http.post<any>(`${this.getResourceUrl()}${tbaId}/search-strategy`, data);
  }
  
  public listAllTbas(): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}`);
  }
  
  public copyfromTba(copyFromTbaId: number, currentTbaId): Observable<any> {
    return this.http.put<any>(`${this.getResourceUrl()}copy/${copyFromTbaId}/to/${currentTbaId}`, { });
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}tbas/`;
  }
}
